module.exports={
	"Form": "TestInstanceEditManifest",
	"Scope": "TestInstance-Edit",
	"Descriptors":
	{
		"TestInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestInstance-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestInstance-Edit-Identity",
				"Group": "TestInstance-Edit-Identity"
			}
		},
		"TestInstanceDetails.IDTestPlan":
		{
			"Name": "Test Plan",
			"Hash": "TestInstance-Edit-IDTestPlan",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "TestPlan",
				"SearchFields":
				[
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestInstance-Edit-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLab":
		{
			"Name": "Lab",
			"Hash": "TestInstance-Edit-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestInstanceDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "TestInstance-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"TestInstanceDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "TestInstance-Edit-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestInstanceDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "TestInstance-Edit-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"TestInstanceDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "TestInstance-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "TestInstance-Edit-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.EstimatedCompletionDate":
		{
			"Name": "Estimated Completion Date",
			"Hash": "TestInstance-Edit-EstimatedCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.ActualCompletionDate":
		{
			"Name": "Actual Completion Date",
			"Hash": "TestInstance-Edit-ActualCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.Status":
		{
			"Name": "Status",
			"Hash": "TestInstance-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.StatusMessage":
		{
			"Name": "Status Message",
			"Hash": "TestInstance-Edit-StatusMessage",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.SampleTestNumber":
		{
			"Name": "Sample Test Number",
			"Hash": "TestInstance-Edit-SampleTestNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.TestResult":
		{
			"Name": "Test Result",
			"Hash": "TestInstance-Edit-TestResult",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "TestInstance-Edit-Details",
				"Group": "TestInstance-Edit-Details"
			}
		},
		"TestInstanceDetails.IDTestInstance":
		{
			"Name": "IDTest Instance",
			"Hash": "TestInstance-Edit-IDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.GUIDTestInstance":
		{
			"Name": "GUIDTest Instance",
			"Hash": "TestInstance-Edit-GUIDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestInstance-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestInstance-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestInstance-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		},
		"TestInstanceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestInstance-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-Edit-DataAudit",
				"Group": "TestInstance-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestInstance-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestInstance-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestInstance-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestInstance-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestInstance-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestInstance-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
